module.exports = __webpack_public_path__ + "img/logoIconBlack.ab55d4ec.png";